module.exports = __webpack_public_path__ + "static/img/10.557b180.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/10.jpg
// module id = g4wU
// module chunks = 0